import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import { AuthService } from '@common/services/AuthService/AuthService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { TaskService } from '@common/services/TaskService/TaskService';
import { EmployeeService } from '@common/services/EmployeeService/EmployeeService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { AreaDetails } from '@common/models/areaDetails.model';
import { TasksData } from '@common/models/tasksData.model';
import { EmployeeDetails } from '@common/models/employeeDetails.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { GetTasksOptions } from '@common/models/getTasksOptions.model';

@Component({
  templateUrl: './progressInAreaView.component.html',
  styleUrls: ['./progressInAreaView.component.scss'],
})
export class ProgressInAreaViewComponent implements OnInit {
  areaKey: string;
  employeeKey: string;
  stateDate: string;
  areaDetails: AreaDetails = {
    areaKey: null,
    areaName: null,
    breadcrumbLevels: {
      clientKey: null,
      clientName: null,
    },
    officeKey: null,
    officeName: null,
    floorName: null,
  };
  breadcrumbLevels;
  employeeDetails: EmployeeDetails = {
    employeeKey: null,
    employeeFirstName: null,
    employeeLastName: null,
    employeeEmail: null,
    employeePhone: null,
    clientAssigned: [],
  };
  tasksData: TasksData = {
    tasks: [],
    tasksNumber: null,
  };
  queryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };
  dataFetchingTimeout;
  @ViewChild('taskTableComponent') taskTableComponent: SortableTableComponent;

  public fields = [
    { shortName: 'taskName', fullName: 'taskName', type: 'string', sortable: true, width: '85%' },
    { shortName: 'state', fullName: 'state', type: 'state', sortable: true, width: '15%', textAlign: 'center' },
  ];

  constructor(
    private route: ActivatedRoute,
    public authService: AuthService,
    public areaService: AreaService,
    public employeeService: EmployeeService,
    public taskService: TaskService,
  ) {}

  ngOnInit() {
    Observable.combineLatest(this.route.params, this.route.queryParams)
      .subscribe((combinedParams) => {
        const [params, queryParams] = combinedParams;

        this.areaKey = params['areaKey'];
        this.employeeKey = queryParams.employeeKey;
        this.stateDate = queryParams.date;
        this.getAreaDetails();
        this.getEmployeeDetails();
        this.getTasks();
      });
  }

  getAreaDetails() {
    this.areaService.getAreaDetails(this.areaKey)
      .subscribe(
        (data: AreaDetails) => {
          this.areaDetails = data;
          this.breadcrumbLevels = [
            {
              clientKey: data.breadcrumbLevels.clientKey,
              clientName: data.breadcrumbLevels.clientName,
            },
            {
              areaKey: data.areaKey,
              areaName: data.areaName,
            },
          ];
        },
        error => this.authService.handleRequestError(error, this.getAreaDetails.bind(this)),
      );
  }

  getEmployeeDetails() {
    this.employeeService.getEmployeeDetails(this.employeeKey)
      .subscribe(
        (data: EmployeeDetails) => {
          this.employeeDetails = data;
        },
        error => this.authService.handleRequestError(error, this.getEmployeeDetails.bind(this)),
      );
  }

  getTasks() {
    const getTasksOptions: GetTasksOptions = {
      areaKey: this.areaKey,
      queryParameters: this.queryParameters,
      stateDate: this.stateDate,
      employeeKey: this.employeeKey,
    };

    this.taskService.getTasks(getTasksOptions)
      .subscribe(
        (data: TasksData) => {
          this.tasksData = data;

          if (this.taskTableComponent) {
            this.taskTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getTasks.bind(this)),
      );
  }

  onParametersUpdated($event) {
    this.queryParameters = Object.assign(this.queryParameters, $event);
    this.getDataWithTimeout(this.getTasks.bind(this));
  }

  getDataWithTimeout(fn) {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/progressInAreaView/progressInAreaView.ts